import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from 'src/app/models/Constants';
import { PrivacyPolicyService } from 'src/app/services/privacy-policy.service';
import { AccountFreezeService } from 'src/app/services/account-freeze.service';
@Component({
  selector: 'app-privacy-policy-modal',
  templateUrl: './privacy-policy-modal.component.html',
  styleUrls: ['./privacy-policy-modal.component.scss']
})
export class PrivacyPolicyModalComponent {
@Output()  goToAuthenticatePageEmitter: EventEmitter<any> = new EventEmitter();
 
  public step1Visible: boolean = true;
  public step2Visible: boolean = false;
  public isButtonDisabled: boolean = false;
  public privacyPolicyConsent: string = Constants.PRIVACY_POLICY_CONSENT;

  constructor(private dialogRef: MatDialogRef<void>,
    public rootScope: RootScopeService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private privacyPolicyService: PrivacyPolicyService,
    private accountFreezeService: AccountFreezeService) { }



  closePolicyPopup() {
    if (this.data) {
      this.rootScope.customerTypeForm.get('customerType')?.setValue(this.rootScope.activeCustTab.customerType);    
    }
    this.dialogRef?.close();   
  }

  updatePrivacyPolicy() {
    this.isButtonDisabled = true;
    if (!this.rootScope.simulationData.isSimulationToggleOn) {
      this.privacyPolicyService.updatePrivacyPolicyStatus(this.rootScope.activeCustTab.clientId).subscribe({
        next: (res: any) => {
          if (res && res?.httpStatusCode == Constants.ERROR_CODE_200) {
            this.accountFreezeService.getPrivacyPolicyStatus();  
            this.isButtonDisabled = false;       
            let obj: any = {};
            this.goToAuthenticatePageEmitter.emit(obj);
          }
          else {
            console.error('Error updating privacy policy status:', res);
            this.rootScope.enableAlerts(Constants.ERROR, Constants.PRIVACY_CONSENT_UPDATE_FAILED_MSG);
          }
          this.closePolicyPopup();
        },
        error: (err) => {
          console.error('Error updating privacy policy status:', err);
          this.rootScope.enableAlerts(Constants.ERROR, Constants.PRIVACY_CONSENT_UPDATE_FAILED_MSG);
          this.isButtonDisabled = false;
          this.closePolicyPopup();
        }
      });
    }
    else {
       this.closePolicyPopup();    
       this.rootScope.activeCustTab.privacyPolicyStatus='false'; /** Setting privacy policy status false for simulation */
       this.isButtonDisabled = false;  
       this.goToAuthenticatePageEmitter.emit({});
    }
  }


}
